<template>
  <div class="VB_Brochure_Contact" :class="{ VB_Brochure_Contact__qr: qr }">
    <pre class="VB_Brochure_Contact_Info" v-html="contact" />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    contact: {
      required: true,
      type: String
    }
  },

  computed: {
    ...mapState({
      qr: s => s.qr
    })
  }
};
</script>

<style lang="scss">
.VB_Brochure_Contact {
  position: absolute;
  top: 15pt;
  right: 24pt;
  width: 210pt;
  overflow: hidden;
  height: 50pt;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;

  &_Info {
    border-left: 1px solid #cacaca;
    padding-left: 8pt;
    font-family: helvetica, arial, sans-serif;
    font-size: 9px;
    font-weight: 700;
    line-height: 1.5;
    max-width: 210pt;
    overflow: hidden;
  }
}

.VB_Brochure_Contact__qr {
  right: 100pt !important;
}
</style>
